// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"edfc9c30","812":"af20cca4"}[chunkId] + ".chunk.js";
};